export interface IDeviceFetchData {
    ipAddress: string;
    port?: number;
    username: string;
    password: string;
    isFile: boolean;
    isAutoLine: boolean;
    dir: string;
    path: string;
    connectionId: string;
    connectionType: string
}

export default class DeviceFetchData implements IDeviceFetchData {
    ipAddress: string;
    port?: number;
    username: string;
    password: string;
    isFile: boolean;
    isAutoLine: boolean;
    dir: string;
    path: string;
    connectionId: string;
    connectionType: string

    constructor(ipAddress: string, username: string, password: string, isFile: boolean, isAutoLine: boolean,
        directory: string,path:string, connectionId: string,
        connectionType: string, port?: number) {
        this.ipAddress = ipAddress;
        this.port = port;
        this.username = username;
        this.password = password;
        this.isFile = isFile;
        this.isAutoLine = isAutoLine;
        this.dir = directory;
        this.path= path;
        this.connectionId = connectionId;
        this.connectionType= connectionType;
    }
}

const defaultDeviceFetchData = new DeviceFetchData("", "", "", false, false, "","", "", "", 0);
export { defaultDeviceFetchData };
